<div class="dialog">
  <span class="dialog-close" (click)="close()">
    <i class="fa fa-close"></i>
  </span>
  <h2 class="dialog-header">{{ modalTitle | translate }}</h2>
  <div class="dialog-content">
    <app-facility-detail
      [facility]="facility"
      [mode]="mode"
      [defaultLanguage]="defaultLanguage"
      [additionalLanguages]="additionalLanguages"
      [isModal]="true"
      (savedFacility)="onSavedFacility($event)"
      (canceledFacility)="onCanceledFacility()"
    ></app-facility-detail>
  </div>
</div>
